import React from "react";
import "./ForgotPasswordPage.css";
import InfoSection from "./components/InfoSection";
import ForgotPasswordForm from "./components/ForgotPasswordForm";

const ForgotPasswordPage = () => {
  return (
    <div className="login-container">
      <div className="login-box">
        <InfoSection />
        <ForgotPasswordForm />
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
